import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '.../../environments/environment';
import { Broadcaster } from '.../../environments/broadcaster';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { LogicalRowDirective } from '@progress/kendo-angular-grid';
import { Color } from '@progress/kendo-drawing';

const moment = _rollupMoment || _moment;


@Component({
  selector: 'routes-assignments',
  templateUrl: './routeAssignment.component.html',
  styleUrls: ['./routeAssignment.component.css'],
})

export class RouteAssignment implements OnInit {
  map: any
  showLoader: boolean;
  public Id;
  public data;
  public userId: any;
  public areaEntityData;
  public staffEntityData;
  public prjData;
  public vehNo;
  public VehiclesByID;
  public VehiclesDataStatus;
  selectedRow: Number;
  selectedAreaRow: Number;
  setClickedRow: Function;
  selectAreaEntityDetailsRow: Function;
  //selectStaffEntityDetailsRow :Function;
  public vehiclesCatogery;
  public vehiclesArealabel: any;
  public stdate: any
  public enddate: any
  public selectPrjId: any
  public SelectVehno: any
  public deleted = false;
  public delwarning = false;
  public updtVehDataSuccess = false;
  public VehicleParkLocation: any
  public selectProjectmodel: any
  public vehAreaModel: any
  public vehiclesAreaEntity: any
  public vehAssignmtStaffRole: any
  public vehStaffRoleModel: any
  public staffRole: any
  public staffNameData: any
  public areaAssignDetails: any
  public staffAssignDetails: any
  public vehStaffNameModel: any
  public vehStaffAsignStatus: any
  
  search: any;
  showDialog: any
  visible: any
  //---------------vehicles Update Details-------------
  //For Update validations  
  public udptVehTypename = false;
  public selectedDate= moment();
  public updtImeiNo = false;
  public udptParkLocation = false;
  public udptDataStatus = false;
  public saveAreaEntityStatus = false;
  public saveStaffNameStatus = false;
  public deleteAreaEntity = false;
  public vehStaffRoleStatus = false;
  public vehStaffRoleNameStatus = false;
  public isVehAssignSave = false;
  public isStaffAssignSave = false;
  public vehiclesNo: any
  public vehTypId: any
  public vehType: any
  public vehCotegaryId: any
  public vehiclesType: any;
  public inActiveVehiclesLst: any;
  public SelectProjectName: any
  public vehCotId: any
  public vehTypeId: any
  public VehiclesNo: any
  public imeidNo: any
  public chaChihNo: any
  public vtsMobileNo: any
  public simNo: any
  public vtsModel: any
  public parkLocations: any
  public installDate: any
  public activationsDate: any
  public vehDataStatus: any
  public isjingleActive: any
  public isActiveStatus: any
  public selectedRowData: any
  public Prjid: any
  public updtCheckVehnoAvl: any
  public updtCheckVehMobileImeiNoAvl: any
  public updtCheckVtsMobileNoAvt: any
  public updtCheckVehChasisNoAvt: any
  public updtCheckSimNoAvt: any
  public vehCatArea: any
  public vehlabelId: any
  public vehEntityArea = false;
  public vehStaffStatus = false;
  public vehAreaEntityModel: any
  public vehEntityData: any
  public vehAreaAsignStatus: any
  public vehStaffRoleId: any
  public project: any
  public updateData: any
  public updtVstDeviceNo: any
  public updtGsmOperator: any
  public updtEntryDate: any
  public currentDate: any
  public projectMaster: any;
  public showHideVehAssignLoadDiv = false;
  public showHideStaffAssignLoadDiv = false
  public imageVehAssignLoader: any;
  public imageStaffAssignLoader: any;
  public vehUpdateBtnDiv = false;
  public vehDeleteBtnDiv = false;
  public vehAssignmentBtnDiv = false;
  public vehActiveBtnDiv = false;
  public showHideVehNoDiv = false;
  public isVehicleUpdtbtn = false;
  public showHideImeiNoDiv = false;
  public imgVehNoPath: any;
  public imgVehImeiNoPath: any;
  public showHideChasisNoDiv: any;
  public imgChasisNoPath: any;
  public imgVtsMobilNoPath: any;
  public showHideVtsMobileDiv = false;
  public imgSimNoPath: any;
  public showHideSimNoDiv = false;
  public employeeRecordNotFound = false;
  public vehAreaRecordNotFound = false;
  public staffAssignReNotFound = false;
  public vehID: any;
  //public staffSelectionsId:any;
  public vtsModalaData: any;
  public vtsData: any;
  public vehOwnerTypeList: any;
  public ownerType: any;
  public VehiclesTempNo: any;
  public vehOwnerTypeData: any;
  public ownerNameModal: any;
  public vtsModal: any;
  public vehOwnerRequired = false;
  public vtsModelRequired = false;
  public updtResponceMsg: any;
  public updtVehDataError = false;
  public saveAreaEntityError = false
  public saveStaffNameError = false;
  public date = moment();
  public polyCords=[];
  routeBoundary;
  changeStatus: any;
  status: any;
  titleData: any;
  successMsg: any;
  currentVehicleId: any;
  driverHistoryData: any;
  routeSelected: boolean;
  beatDetails: any;
  beatName: any;
  routeDetails: any;
  isBeatNull: boolean;
  routeList: any;
  isRouteSelected: boolean;
  singleRouteDetails: any;
  isNameUpdating: boolean;
  routeName: any;
  updateNameSuccess: boolean;
  updateNameError: boolean;
  selectedRouteId: any;
  geocoder: google.maps.Geocoder;
  routePolygondData: any;
  authtoken: any;
  polygondData: any;
  routePath: any[];
  route: google.maps.Polyline;
  
  tempVehiclesData: any;
  vehiclesData: any;
  selectedVehs: any;
  formattedSelectedDate: string;
  routesData:any
  alarmList: any;

  allalaramdata : any ;


  singleVehAlarmPoints: any;
  testing: any;
  km: any;
  
  constructor(private http: HttpClient, private broadcaster: Broadcaster, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.vehOwnerTypeList = [{ "ID": 1, "VALUE": "Ecogreen" }, { "ID": 2, "VALUE": "Contractor" }]
    this.authtoken = JSON.parse(localStorage.getItem('authData'));
    this.selectedVehs = [];
    this.formattedSelectedDate = moment().format('YYYY-MM-DD');
  }
  ngOnInit(): void {

    $("#progress-bar").hide()
    this.Prjid = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id;
    if (this.Prjid == 1) {
      this.SelectProjectName = "LUCKNOW";
    } else if (this.Prjid == 2) {
      this.SelectProjectName = "GURUGRAM";
    } else if (this.Prjid == 3) {
      this.SelectProjectName = "FARIDABAD";
    } else if (this.Prjid == 4) {
      this.SelectProjectName = "GWALIOR";
    }

    

    this.geocoder = new google.maps.Geocoder();
    var myOptions = {
        center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
        zoom: 12,

        mapTypeControl: true,
        mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.LEFT_BOTTOM
        },

        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        
        scaleControl: false,
        fullscreenControl: true,
        streetViewControl: false
    };

    this.map = new google.maps.Map(document.getElementById('map'), myOptions);
  
    this.getDataWhenProjectChange(this.Prjid);
   // this.getAllRoutesMapped()
    //this.getTodaysRunningVehicleDetails();
    this.getRoutesAssignedForVehicles();

    
    
  }

  async plotRouteBoundary(entityId) {
    this.loaderService.display(true);
    if (!this.routeBoundary) {
        // this.map.data.forEach((feature) => {
        //     if (feature.getProperty('Oemid') == entityId) {
        //         this.map.data.remove(feature);
        //     }
        // });
        this.loaderService.display(false);
    } else {
        if (this.routePolygondData) {
            this.map.data.addGeoJson(this.routePolygondData.geoJson);
           
            
            
            var currentdata ='';
            this.map.data.addListener('mouseover', function(event) {
                var position = {  lat: event.latLng.lat(), lng: event.latLng.lng() };
                var infoWindow = new google.maps.InfoWindow();
               // infoWindow.close(this.map);
                var content =
                "<div class='col-sm-12'>" +
                "<p class='info-deatil'><strong>Entry ID :</strong>" +
                '  ' +
                event.feature.getProperty('mainId')  +
                "</p><p class='info-deatil'><strong>Name :</strong>" +
                '  ' +
                event.feature.getProperty('title')
                
                '</p></div>';
            infoWindow = new google.maps.InfoWindow({
                content: content,
                position: position
            });

          //  google.maps.InfoWindowOptions;
           this.selectedLineDetails= event.feature.getProperty('mainId');
                
              
              });

             this.loaderService.display(false);
        }
        else {
            alert('Please wait while the data is being fetched. This may take upto one minute. Thank You!')
            this.routeBoundary = false;
            this.loaderService.display(false);
        }
    }
}

dateChanged() {
 
  this.formattedSelectedDate = moment(this.selectedDate).format('YYYY-MM-DD');
 
}

 
  
  getAllRoutesMapped() {
    this.loaderService.display(true);
    $('button').click( function() {
      $(this).addClass('btn-primary').removeClass('btn-default').siblings().removeClass('btn-primary').addClass('btn-default');
    });
    
    this.http.get(environment.apiUrl + 'entity/getAllRoutePolygons?wardid=&prjid=' + this.Prjid).subscribe((data) => {
      this.data = data;

      console.log(data);
      

      // for (let index = 0; index < this.data.length; index++) {
        
      //   this.onclickGetRoutePolygon(this.data[index]);
        
      // }

      this.routePolygondData = data;
      this.map.data.addGeoJson(this.routePolygondData.geoJson);
       
      if (this.data.length > 0) {
         this.loaderService.display(false);
      }
      else {
         this.loaderService.display(false);
      }
    });
  } 

  
   async getRoutesAssignedForVehicles() {

    this.loaderService.display(true);
    $('button').click( function() {
      $(this).addClass('btn-primary').removeClass('btn-default').siblings().removeClass('btn-primary').addClass('btn-default');
    });
    
    this.http.get(environment.apiUrl + 'admin/getRoutesAssignedForVehicles?prjid='+this.Prjid).subscribe(async (dataJason) => {

      var result: any

      result = dataJason

      //console.log(result.entityData[].IMEI);
      
       
      var data = [];
      //console.log(result.entityData[0].vehno);
      //console.log(result.entityData[0].ENTITYNAME);
      
      //var coordinates2 = result.geoJson.features

      var coordinates2 = result.entityData

      
   
      var routesKm = [];

      var newdata = [] ;
      for (let i = 0; i <coordinates2.length; i++) {
              //console.log(coordinates2.length);
              

              var coordinates =  result.geoJson.features[i].geometry.coordinates;
              var newArr = [];

              for(var j = 0; j < coordinates.length; j++){
                 newArr.push({ lat:coordinates[j][1],lng:coordinates[j][0]})
              } 

              var newCords = new google.maps.Polyline({
                                       path: newArr,
                                       strokeColor: '#121C11',
                                       strokeOpacity: 0.0,
                                       strokeWeight: 0,
                                       //map: this.map
              });

             var testing = 	google.maps.geometry.spherical.computeLength(newCords.getPath());  


          //    routesKm.push({'routeID':coordinates2[i].eid,'distance':Math.round(testing / 100) / 10});
             
             
             // console.log(testing);
              
               
             
            //  data[i].Route_Percentage = '100 %',
            //  data[i].Route_Coverd = '--',
            //  data[i].result.entityData[i].vehno
            //  data[i].result.entityData[i].ENTITYNAME

            // this.km = 0;
          

            // await  this.alarmsDataKM(result.entityData[i].IMEI).then( res => {
            //   //console.log("447",res);
               
            //   this.km = res 

            //   if(this.km != 0)
            //     {
            //       this.km = Math.round(this.km /100) / 10;
            //     }
    
            
              
            // })


            data.push({
              Route_Percentage:'',
              Route_coverted :Math.round(testing / 1000),
              vehnum :result.entityData[i].vehno,
              EntityNum:result.entityData[i].ENTITYNAME,
              imei:result.entityData[i].IMEI,
              veid:result.entityData[i].vehid,
              eid:result.entityData[i].eid
            })



      } 

    //  this.updateRoutesEntityDistanceKm(routesKm);
      

        this.routesData =  data ;

        console.log(  this.routesData);
        
          
      //  this.newrefreshCount(totalImei,result) 


   

      // var newdata = []

      // for (let i = 0; i < totalImei.length; i++) {
        
      //   await  this.alarmsDataKM(totalImei[i]).then( res => {
      //     //console.log("447",res);

      //     newdata.push(res)
          
      //   })

        

      // }

      
      this.loaderService.display(false);

 
    });

    //this.loaderService.display(false);
    
  } 
  
  
  
  
  
  updateRoutesEntityDistanceKm(data){

    var passData = {
      'data':data
    };

    this.http.post(environment.apiUrl + 'admin/updateRoutesEntityDistanceKm', passData).subscribe((data) => {
      console.log(data);
      
    });

  }


  getRouteAndCoveredRoute(item,i){

  
  

    var inital =  document.getElementById('changeback'+i).style.background = 'red' ;
       
    
   
         
  

    
    this.loaderService.display(true);

    this.onclickGetRoutePolygon(item.veid, item.eid)
    this.plotAllVehiclesCoveredRoutes(item.imei)

   
  }

  getDataWhenProjectChange = async (id) => {
    $('#loderImgTab').show();
    this.loaderService.display(true);
      let polygon = await fetch(
        environment.apiUrl + 'entity/getPolygonByOemId' + '?prjid=' + id + '&wardOemId=null' + '&beatOemId=null',
        {
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: this.authtoken.token
            }
        }
    );
    this.polygondData = await polygon.json();
     // this.zonesListing = this.zonesData.entityname
    // console.log("Zonesssss", this.zonesData)

  
    this.map.data.addGeoJson(this.polygondData.geoJson);
   
};

removeAssignRoute() {
  this.map.data.forEach((feature) => {
    this.map.data.remove(feature);
    //   if (feature.getProperty('Oemid') == 10) {
    //       this.map.data.remove(feature);
    //   }
    //   if (feature.getProperty('Oemid') == 29) {
    //     this.map.data.remove(feature);
    // }
  });
}

  async onclickGetRoutePolygon(routeId, eid){
    //this.removeAssignRoute();
     
  
  await  this.http.get(environment.apiUrl + 'entity/getPolygonByEntityID?prjid=' + this.Prjid+"&entityID="+eid).subscribe((data) => {
      var result: any;
      result = data; 
      
      this.routePolygondData = result;
     // this.removeAssignRoute();
      this.highLightAssignBeat(eid);
      this.map.data.addGeoJson(this.routePolygondData.geoJson);
      
 
    });
     
   
   
   
  }

  

async getTodaysRunningVehicleDetails(){
  let d = await fetch(
    environment.apiUrl +
    'vehicles/getAll?prjId=' +
    this.Prjid +
    '&date=' +
    moment(this.date).format('YYYY-MM-DD'),
    {
        method: 'get',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token
        }
    }
);
this.tempVehiclesData = await d.json();
console.log("Oh Dammit", this.tempVehiclesData.liveData);

this.vehiclesData = this.tempVehiclesData.liveData


    

}

plotAllRoutesAtOnce(){

  console.log(this.formattedSelectedDate);
  

  var chekcForLastClick = this.getTimeDiff();

    if(chekcForLastClick == 'ok')
      {
        let date = moment(this.date).format('YYYY-MM-DD HH:mm:ss');
        localStorage.setItem('plotAllRoutesAtOnce', 'clicked');
        localStorage.setItem('plotAllRoutesAtOnceTime', date);

        this.loaderService.display(true);
      
        for (let index = 0; index < this.vehiclesData.length; index++) {
      
            
          this.plotAllVehiclesCoveredRoutes(this.vehiclesData[index]);
          
        }

        this.loaderService.display(false);
      }
      else
      {
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'Data will reflect in every 2 hours.',
      })
      }

  
}


public getTimeDiff(){
  

  var storedDatetime = localStorage.getItem('plotAllRoutesAtOnceTime');

  if(storedDatetime == '' || storedDatetime == null)
    {
      return 'ok';
    }
  else
  {
    var end = moment.utc(storedDatetime).format("YYYY-MM-DD HH:mm:ss").toString();
    var now = moment().format("YYYY-MM-DD HH:mm:ss").toString(); //todays date
  
  var status = '';
 
var diff = moment.duration(moment(now).diff(moment(end)));
  
  var hours = Math.floor(diff.asHours());
  var minutes = Math.floor(diff.asMinutes());

  

   
  if(minutes > 120)
  {
    status='ok';
  }
else
  {
    status = 'no';
  }

  console.log(storedDatetime, minutes, status);

  return status;
  }

 
  
}
 

getValue(data){

  var checkVal = this.selectedVehs.indexOf(data.IMEI);

  if(checkVal !== -1){
    this.selectedVehs.splice(checkVal, 1); 
} else{
  this.selectedVehs.push(data.IMEI);
}
console.log(this.selectedVehs);

this.plotAllVehiclesCoveredRoutes(data);

}

highLightAssignBeat(entityId) {
  this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor');
      var strokeColor = feature.getProperty('Bcolor');
      if (feature.getProperty('EntityID') == entityId) {
          return {
              fillColor: '#3E0560',
              strokeColor: '#3E0560',
              strokeWeight: 2,
              fillOpacity: 0.5,
              strokeopacity: 0.4
          };
      } else if (feature.getProperty('TYPE') == 'stopMarker') {
          if (feature.getProperty('difInMinutes') > 20) {
              var icon = 'assets/img/delayStop.png';
          } else {
              var icon = 'assets/img/stopMarker.png';
          }
          return {
              fillColor: color,
              strokeColor: strokeColor,
              strokeWeight: 2,
              fillOpacity: 0.05,
              icon: icon,
              strokeopacity: 0.2,
              label: {
                  text: feature.getProperty('number'),
                  color: '#FFFFFF',
                  fontSize: '13px',
                  background: 'yellow',
                  fontWeight: 'bold',
                  AlignmentVertical: 'top',
                  AlignmentHorizontal: 'center'
              },
              labelClass: 'my-custom-class-for-label'
          };
      } else if (feature.getProperty('TYPE') == 'khatta') {
          return {
              fillColor: color,
              strokeColor: strokeColor,
              strokeWeight: 5,
              fillOpacity: 0.0,
              strokeopacity: 0.2,
              icon: 'assets/img/khatta.png'
          };
      } else if (
          feature.getProperty('Oemid') == 8 ||
          feature.getProperty('Oemid') == 9 ||
          feature.getProperty('Oemid') == 10 ||
          feature.getProperty('Oemid') == undefined
      ) {
          return {
              fillColor: color,
              strokeColor: strokeColor,
              strokeWeight: 3,
              fillOpacity: 0.1,
              strokeopacity: 0.8
          };
      } else {
          return {
              fillColor: color,
              strokeColor: '#040C0A',
              strokeWeight: 4,
              fillOpacity: 0.1,
              strokeopacity: 0.4
          };
      }
  });
}

  async plotAllVehiclesCoveredRoutes(IMEI){

    let date = moment(this.date).format('YYYY-MM-DD');
    let response = await fetch(
      environment.apiUrl + 'vehicles/route' + '?DEVICEID=' + IMEI + '&prjId=' + this.Prjid + '&date='+this.formattedSelectedDate+'&accuracy=' +
      false,
      {
          method: 'get',
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: this.authtoken.token
          }
      }
  );
  let result = await response.json();

  if (result.status != 'No Route Found') 
      {

        
        
        this.createRoute(this.map, result.latLong);
      }else{
        this.loaderService.display(false);
      }
    
       
  }

  createRoute(map, pathCoords) {
    var i, route, marker;

    if(this.polyCords.length > 0)
      {
          
        this.polyCords = [];
        this.route.setMap(null);
        this.route = null;
      }


      for (i = 0; i < pathCoords.length; i++) {
        this.polyCords.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) });
    } 
    this.routePath = this.polyCords;
    this.route = new google.maps.Polyline({
        path: this.polyCords,
        
        strokeColor: '#E2EF16',
        strokeOpacity: 4.0,
        strokeWeight: 5,
       
        //map: map
    });
    this.route.setMap(map);
    this.loaderService.display(false);
 }


  importVehiclesExcelReport(data) {
    const ws_name = 'VehicleReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, {
      bookType: 'xlsx', bookSST: true, type:
        'binary'
    });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }


   /// second km  one vrhicle

   async newrefreshCount(data,id) {
    
    var selectedImei = data.imei;
    var fixedRoute = data.Route_coverted;
  
    var dataObj = {
        prjId: this.Prjid,
        date: moment(this.date).format('YYYY-MM-DD'),
        imei: selectedImei
    };

 
    
   await this.http.post(environment.apiUrl + 'getVehicleAlarmsByIMEI', dataObj).subscribe((data) => {
        this.alarmList = data;


           this.singleVehAlarmPoints = this.alarmList.filter(
            (item) => item.IMEI == selectedImei && item.alarmTypeId ==  1
           );
            
             var len = this.singleVehAlarmPoints.length

             var newArrytwo =[] ;
              
           for(var i = 0; i < this.singleVehAlarmPoints.length; i++)
           {
              newArrytwo.push({lat:parseFloat(this.singleVehAlarmPoints[i].lat),lng:parseFloat(this.singleVehAlarmPoints[i].long)})
           } 

        var newCordss = new google.maps.Polyline({
           path: newArrytwo,
           strokeColor: '#121C11',
           strokeOpacity: 0.0,
           strokeWeight: 0,
       });

       var testing = 	google.maps.geometry.spherical.computeLength(newCordss.getPath()); 

       console.log(testing);


       var calc = Math.round(testing / 100) / 10;

       var subtractVal = calc - fixedRoute;

       document.getElementById('coveredRouteNum'+id).innerHTML  = (subtractVal).toString();
         
                
       
    });


  
    
  
    
   }
   

   async alarmsDataKM(totalImei) {

    return new Promise((resolve ,reject)=>{
      var dataObj = {
        prjId: this.Prjid,
        date: moment(this.date).format('YYYY-MM-DD')
       };
       
   
        this.http.post(environment.apiUrl + 'getVehicleAlarms', dataObj).subscribe((data)=>{
         
  
           this.allalaramdata = data
          if(this.allalaramdata > 0)
            {
              this.singleVehAlarmPoints = this.allalaramdata.filter(
                (item) => item.IMEI == totalImei && item.alarmTypeId ==  1
               );
    
               var len = this.singleVehAlarmPoints.length
    
               var newArrytwo =[] ;
                
               //console.log(this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long);
               
    
             for(var i = 0; i < this.singleVehAlarmPoints.length; i++)
             {
                //this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long
    
                newArrytwo.push({lat:parseFloat(this.singleVehAlarmPoints[i].lat),lng:parseFloat(this.singleVehAlarmPoints[i].long)})
             } 
    
           //console.log(newArrytwo);
           
    
          var newCordss = new google.maps.Polyline({
             path: newArrytwo,
             strokeColor: '#121C11',
             strokeOpacity: 0.0,
             strokeWeight: 0,
             //map: this.map
       
         });
    
         this.testing = 	google.maps.geometry.spherical.computeLength(newCordss.getPath()); 
    
         //console.log("859", this.testing);
        
         resolve(this.testing) ;
            }

            else
            {
              resolve(0) ;
            }

          
         
  
       }
  
  
       )
  
  });

  
  }







  ////// save cron data testing #atul


  saveCronData(){

    console.log("testing");
    this.http.get(environment.apiUrl + 'vehicles/saveCronData?prjid='+2).subscribe((data)=>{

      console.log(data);
      


    })


  }






} 


// WEBPACK FOOTER //
// ./src/app/admin/vehicles/routesAssignments/routeAssignment.component.ts